import Axios from "axios";
import { PartnerAnalyticsParametersInterface } from "./interfaces/PartnerAnalyticsParametersInterface";
import { PartnerAnalyticsDataInterface } from "./interfaces/PartnerAnalyticsDataInterface";

export class AnalyticsRepository {
    partnerData(params: PartnerAnalyticsParametersInterface): undefined | Promise<PartnerAnalyticsDataInterface> {
        if (!process.env.VUE_APP_ADMIN_PANEL_URL) {
            return undefined;
        }

        return Axios.post(`${process.env.VUE_APP_ADMIN_PANEL_URL}/api/statistics`, params)
            .then(({ data }) => {
                return data?.data as PartnerAnalyticsDataInterface;
            });
    }

    async visitorsReport(params: PartnerAnalyticsParametersInterface) {
        return Axios.post(`${process.env.VUE_APP_ADMIN_PANEL_URL}/api/statistics/visitors-report`, params, {
            responseType: "blob",
            headers: {
                "Access-Control-Allow-Origin": "*"
            }
        });
    }
}
